import { styled as o, Box as a, Typography as u } from "@mui/material";
import d from "../../../assets/icons/icon-empty.svg.js";
import f from "../../../assets/icons/icon-lootrush.png.js";
import y from "../../../assets/icons/icon-marketplace.png.js";
import g from "../apeiron/ApeironLinkButton.js";
import m from "./IconText.js";
import b from "../next/Image.js";
import * as r from "ramda-adjunct";
import { useTranslation as w } from "react-i18next";
import { jsxs as s, jsx as e } from "react/jsx-runtime";
const N = o(a)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0px;
  height: 100%;

  ${(t) => t.theme.breakpoints.up("res480")} {
    font-size: 24px;
    line-height: 30px;
  }
  ${(t) => t.theme.breakpoints.down("res480")} {
    font-size: 26px;
    line-height: 30px;
  }
`, k = o(b)`
  aspect-ratio: 1;
  ${(t) => t.theme.breakpoints.up("res480")} {
    width: 120px;
    margin-bottom: 40px;
  }
  ${(t) => t.theme.breakpoints.down("res480")} {
    width: 100px;
    margin-bottom: 16px;
  }
`, E = o(u)`
  font-size: 22px;
  font-weight: 300;
  color: unset;
`, S = o(a)`
  display: flex;
  column-gap: 40px;
  row-gap: 30px;
  margin-top: 40px;
  flex-wrap: wrap;
  justify-content: center;
`, c = o(g)`
  background-color: #321d5e;
  border-radius: 5px;
  border: 2px solid #5e35b2;
  padding: 10px 45px;
  min-width: 270px;
`, B = o(c)`
  border: unset;
  background-color: white;
`, C = o(m)`
  gap: 20px;
  .Custom-Icon {
    aspect-ratio: 130 / 38;
    width: 100px;
  }
  .Custom-Text {
    font-size: 18px;
    font-weight: 500;
  }
`, R = o(m)`
  gap: 6px;
  .Custom-Icon {
    filter: brightness(0);
    aspect-ratio: 1;
    width: 26px;
  }
  .Custom-Text {
    color: black;
    font-size: 18px;
    font-weight: 500;
  }
`, A = (t) => {
  const {
    buyURL: n,
    className: l,
    description: x,
    rentURL: i
  } = t, {
    t: p
  } = w(), h = r.isNotNilOrEmpty(n) || r.isNotNilOrEmpty(i);
  return /* @__PURE__ */ s(N, {
    className: l,
    children: [/* @__PURE__ */ e(k, {
      className: "Custom-Search-Empty-Icon",
      src: d
    }), /* @__PURE__ */ e(E, {
      className: "Custom-Search-Empty-Description",
      children: x || p("common.empty_list")
    }), h && /* @__PURE__ */ s(S, {
      children: [r.isNotNilOrEmpty(i) && /* @__PURE__ */ e(c, {
        "aria-label": "Rent in Lootrush",
        url: i,
        target: "_blank",
        children: /* @__PURE__ */ e(C, {
          text: p("empty_search.rent"),
          endSrc: f.src
        })
      }), r.isNotNilOrEmpty(n) && /* @__PURE__ */ e(B, {
        "aria-label": "Buy in Emporium",
        url: n,
        target: "_blank",
        children: /* @__PURE__ */ e(R, {
          text: p("empty_search.buy"),
          startSrc: y.src
        })
      })]
    })]
  });
};
export {
  A as default
};
//# sourceMappingURL=SearchEmptyState.js.map
